<div class="profile-layout reverse">
    <div class="profile-layout-content">
        <app-comments-card [applicant]="applicant"></app-comments-card>
    </div>
    <div class="profile-layout-sidebar">
        <app-job-postings-card [applicant]="applicant"></app-job-postings-card>
        <app-application-information-card
            *ngIf="applicant"
            [applicationInformation]="{ createdAt: applicant.createdAt, source: applicant.applicationSource }"
        >
        </app-application-information-card>
    </div>
</div>
